import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BillingComponent } from './billing.component';


const routes: Routes = [
  { path: 'list', component: BillingComponent,  pathMatch : 'full' },
  { path: '**', redirectTo : 'list' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BillingRoutingModule { }
